type PropsType = {
  stroke?: string;
};

const InfoIcon = ({ stroke }: PropsType) => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 22.6667V17M17 11.3333H17.0142M11.05 29.75H22.95C25.3302 29.75 26.5203 29.75 27.4295 29.2868C28.2291 28.8793 28.8793 28.2291 29.2868 27.4295C29.75 26.5203 29.75 25.3302 29.75 22.95V11.05C29.75 8.66978 29.75 7.47967 29.2868 6.57054C28.8793 5.77085 28.2291 5.12068 27.4295 4.71322C26.5203 4.25 25.3302 4.25 22.95 4.25H11.05C8.66978 4.25 7.47967 4.25 6.57054 4.71322C5.77085 5.12068 5.12068 5.77085 4.71322 6.57054C4.25 7.47967 4.25 8.66978 4.25 11.05V22.95C4.25 25.3302 4.25 26.5203 4.71322 27.4295C5.12068 28.2291 5.77085 28.8793 6.57054 29.2868C7.47967 29.75 8.66978 29.75 11.05 29.75Z"
        stroke={stroke || '#0C314E'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default InfoIcon;
